/**
 * @generated SignedSource<<d4edfe77d3ec6f6e4eefae44a718f099>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PageHeaderLoomButton_contentContributors$data = {
  readonly isCurrentUserContributor: boolean | null;
  readonly " $fragmentType": "PageHeaderLoomButton_contentContributors";
};
export type PageHeaderLoomButton_contentContributors$key = {
  readonly " $data"?: PageHeaderLoomButton_contentContributors$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageHeaderLoomButton_contentContributors">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "PageHeaderLoomButton_contentContributors",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isCurrentUserContributor"
    }
  ],
  "type": "ContentContributors"
};

(node as any).hash = "01f12bcffbae86c20e6cf7df999dadf4";

export default node;
